"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEscapeManager = exports.escapeManager = exports.EscapeManagerProvider = exports.EscapeManager = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EscapeManager = exports.EscapeManager = /*#__PURE__*/function () {
  function EscapeManager() {
    _classCallCheck(this, EscapeManager);
    _defineProperty(this, "closableStack", []);
    _defineProperty(this, "handleKeydown", e => {
      if (e.key === 'Escape' && this.closableStack.length) {
        this.closableStack[this.closableStack.length - 1]();
      }
    });
  }
  return _createClass(EscapeManager, [{
    key: "register",
    value: function register(onEscape) {
      if (this.closableStack.length === 0) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      this.closableStack.push(onEscape);
    }
  }, {
    key: "unregister",
    value: function unregister() {
      this.closableStack.pop();
      if (this.closableStack.length === 0) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
    }
  }]);
}();
var escapeManager = exports.escapeManager = new EscapeManager();
var EscapeManagerContext = /*#__PURE__*/(0, _react.createContext)(null);
var useEscapeManager = () => (0, _react.useContext)(EscapeManagerContext);
exports.useEscapeManager = useEscapeManager;
var EscapeManagerProvider = _ref => {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(EscapeManagerContext.Provider, {
    value: escapeManager
  }, children);
};
exports.EscapeManagerProvider = EscapeManagerProvider;
//# sourceMappingURL=useEscapeManager.js.map